export enum CallTypes {
  directConnect = "dc",
  vCare = "vcare",
  patientEncounter = "pe",
  caseQueue = "cq",
  vClinicalInformatics = "vci"
}
